export const columns = [
  {
    title: 'SKU',
    field: 'articleId',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nume articol',
    field: 'articleName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data amanare',
    field: 'snoozeStart',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true
  },
  {
    title: 'Data finalizare amanare',
    field: 'snoozeEnd',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true
  },
  {
    title: 'Utilizator',
    field: 'createdBy',
    align: 'left',
    type: 'string',
    disableSorting: true,
    collapsible: true
  }
]
